// SPID-230 / A10: the product media toggle buttons are 0x0 and live in a horizontal slider, so keyboard focus
// can land on a slide that is off-screen. Bring the focused slide into view; tab order is unchanged.
document.addEventListener('focusin', function (e) {
  var t = e.target;
  if (!t || !t.classList || !t.classList.contains('product__media-toggle')) return;
  var slide = t.closest('.product__media-item, li, .slider__slide') || t.parentElement;
  if (slide && slide.scrollIntoView) slide.scrollIntoView({ block: 'nearest', inline: 'center' });
});
